import type { Editor } from '@tiptap/react';
import type { UndoRedoCommandInterface } from '../../../UndoRedo/UndoRedoCommand.ts';

export class TiptapUndoRedoCommand implements UndoRedoCommandInterface {
  private editor: Editor;
  private resizeUndoCallback?: () => Promise<void>;
  private resizeRedoCallback?: () => Promise<void>;

  constructor(editor: Editor, resizeUndoCallback?: () => Promise<void>, resizeRedoCallback?: () => Promise<void>) {
    this.editor = editor;
    this.resizeUndoCallback = resizeUndoCallback;
    this.resizeRedoCallback = resizeRedoCallback;
  }

  async undo(): Promise<boolean> {
    if (!this.editor.can().undo()) return false;

    this.editor.commands.undo();

    await this.resizeUndoCallback?.();

    return true;
  }

  async redo(): Promise<boolean> {
    if (!this.editor.can().redo()) return false;

    this.editor.commands.redo();

    await this.resizeRedoCallback?.();

    return true;
  }
}
